import React, { useEffect, useState } from "react";
import DTOBankDetailModal from "./DTOBankDetailModal";
import BankDetailModalPresenter from "./BankDetailModalPresenter";
import { updatePersonalDetailsService } from "../../../../api/services/updatePersonalDetailsService";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { bankInfoType } from "../../../interfaces/myProfile/personalDetails/bankInfoType";
import { getBankInfoReducer } from "../../../../infra/aggregates/myProfile/bankInfoSlice";
import toast from "react-hot-toast";
import { setLoading } from "../../../../infra/aggregates/LoaderSlice";
import { userService } from "../../../../api/services/userService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
  bankInfoData?: any;
}

const BankDetailModalController = ({
  isModalOpen,
  closeModal,
  trans,
  bankInfoData,
}: ModalInterface) => {
  const [payout_types, set_payout_types] = useState([]);
  const [fields_of_banks, setfields_of_banks] = useState<any>([]);
  const [fields_of_exchange, setfields_of_exchange] = useState<any>([]);

  const [bankNameList, setBankNameList] = useState<any>([]);
  const [exchangeNameList, setExchangeNameList] = useState<any>([]);

  const selector = useAppSelector((state) => state.bankInfoSlice);
  const empId = useAppSelector((state) => state?.authSlice?.emp_id);
  const companyId = useAppSelector((state) => state?.authSlice?.company_id);

  const isLoading = useAppSelector((state) => state?.LoaderSlice.Loading);

  const dispatch = useAppDispatch();

  const getData = (bankInfo_data: any) => {
    updateBankDetail(bankInfo_data);
  };
  async function updateBankDetail(data: any) {
    dispatch(setLoading(true));
    if (empId && data) {
      const payload = {
        emp_id: empId,
        fields: data?.fields?.filter(
          (item: any) =>
            !('company_mode_of_payment' in item) &&
            !('company_bank_or_exchange' in item)
        ),
        payoutypeID: data?.payoutypeID,
        locale: localStorage.getItem("emplang"),
      };
      await updatePersonalDetailsService
        .updateBankDetail(payload)
        .then((response: any) => {
          if (response.response == "success") {
            refreshData();
            toast.success(trans("Updated Successfully"));
            closeModal();
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          const _errors =
            err?.response?.data?.errors &&
            Object.keys(err?.response?.data?.errors);
          toast.error(
            err?.response?.data?.errors
              ? `${_errors.toString().toUpperCase()} Required!`
              : err?.response?.data?.data
                ? err?.response?.data?.data
                : err?.response?.data?.message
          );
        });
    } else {
      dispatch(setLoading(false));

      toast.error(trans("Invalid data!"));
    }
  }

  const refreshData = () => {
    userService
      .getBankDetail(companyId, empId)
      .then((res: any) => {
        if (res?.response == "success") {
          dispatch(getBankInfoReducer(res?.data));
          dispatch(setLoading(false));
        } else {
          return;
        }
      })
      .catch((err) => console.log("err while getting bank detail--", err));
  };

  const getPayoutTypes = (data: []) => {
    set_payout_types(data);
  };
  function getBankFields(data: any) {
    const removecompanySource = data?.filter((item: any) => (item.field_name != 'company_mode_of_payment' && item.field_name != 'company_bank_or_exchange'))
    setfields_of_banks(removecompanySource);
  }
  function getExchangeFields(data: any) {
    const removecompanySource = data?.filter((item: any) => (item.field_name != 'company_mode_of_payment' && item.field_name != 'company_bank_or_exchange'))
    setfields_of_exchange(removecompanySource);
  }
  function get_All_Bank_names(data: any) {
    setBankNameList(data);
  }
  function get_All_exchange_names(data: any) {
    setExchangeNameList(data);
  }
  return (
    <div>
      <DTOBankDetailModal
        setPayoutTypes={getPayoutTypes}
        setBank_Fields={getBankFields}
        setExchange_Fields={getExchangeFields}
        setAll_Bank_Names={get_All_Bank_names}
        setAll_Exchange_Names={get_All_exchange_names}
      />
      <BankDetailModalPresenter
        callBackSubmit={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        isLoading={isLoading}
        selectedEmployeeDetail={selector}
        trans={trans}
        bankInfoData={bankInfoData}
        payout_types={payout_types}
        fields_of_banks={fields_of_banks}
        fields_of_exchange={fields_of_exchange}
        bankNameList={bankNameList}
        exchangeNameList={exchangeNameList}
      />
    </div>
  );
};

export default BankDetailModalController;
